export default (settings: any) => settings['fileUploadCloud'] * 4
